import { gql } from '@apollo/client';

export const UPDATE_NE_AGS = gql`
  mutation updateNeAGS($nutritionalEvaluationAgs: NeAgsInput!) {
    updateNeAgs(nutritionalEvaluationAgs: $nutritionalEvaluationAgs) {
      id
    }
  }
`;
